import React from "react";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../assets/styling/brand-logo.css";

const BRAND_LOGO_SRC =
  "https://d2oa23hr7q6t96.cloudfront.net/database/tbbheader-sanantonio.png";
const BRAND_LOGO_ALT = "San Antonio — The Boss Brief";

export default function BrandLogo({ className = "" }) {
  return (
    <Navbar.Brand
      as={Link}
      to="/"
      aria-label="Home"
      className={`tbb-brand-logo ${className}`}
    >
      <img
        className="tbb-brand-logo__img"
        src={BRAND_LOGO_SRC}
        alt={BRAND_LOGO_ALT}
        loading="eager"
        decoding="async"
        // React doesn't recognize `fetchPriority` yet; use the lowercase attribute to avoid warnings.
        fetchpriority="high"
      />
      <span className="tbb-brand-logo__srText">{BRAND_LOGO_ALT}</span>
    </Navbar.Brand>
  );
}
